import React from 'react'
import classNames from 'classnames'
import { EloCheckboxIcon } from '@elo-ui/components/icons/regular'

const TextSubtitleOptionComponent = (props) => (
  <div
    className={classNames('elo-react-select__option', { 'elo-react-select__option--is-selected': props.isSelected })}
    onClick={() => {
      props.selectOption(props.data)
    }}
  >
    <div className='elo-react-select__option--column'>
      <div className='elo-react-select__option--title'>{props.data.label}</div>
      <div className='elo-react-select__option--subtitle'>{props.data.subtitle}</div>
    </div>

    {props.isSelected && <EloCheckboxIcon />}
  </div>
)

export { TextSubtitleOptionComponent }
